// extracted by mini-css-extract-plugin
module.exports = {"invalidPassResetLink":"styles_invalidPassResetLink__3JkeP","img":"styles_img__1nFTl"};